import axiosConfig from "./axiosConfig";

export type AxpoCounterInvoiceDownloadKind =
  | "source-pdf"
  | "source-xlsx"
  | "counter"
  | "counter-pdf";

export interface AxpoCounterInvoiceDownloadUrlSyncResponse {
  url: string;
  filename: string;
}

// counter-pdf can also return a 202 + LRO handle when the underlying
// docx-to-pdf conversion isn't cached yet. The FE polls /async_status,
// then re-calls the endpoint to get the now-cached URL.
export interface AxpoCounterInvoiceDownloadLroResponse {
  operationKey: string;
  status: "pending" | "running" | "completed" | "failed";
  siteId: string;
}

export type AxpoCounterInvoiceDownloadUrlResponse =
  | AxpoCounterInvoiceDownloadUrlSyncResponse
  | AxpoCounterInvoiceDownloadLroResponse;

export const isAxpoCounterInvoiceDownloadLroResponse = (
  response: AxpoCounterInvoiceDownloadUrlResponse
): response is AxpoCounterInvoiceDownloadLroResponse =>
  typeof (response as AxpoCounterInvoiceDownloadLroResponse).operationKey ===
  "string";

const getAxpoCounterInvoiceDownloadUrl = async (
  authToken: string,
  pairingId: string,
  kind: AxpoCounterInvoiceDownloadKind
): Promise<AxpoCounterInvoiceDownloadUrlResponse> => {
  const { data } = await axiosConfig.get(
    `/admin/axpo-counter-invoice/${pairingId}/download/${kind}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getAxpoCounterInvoiceDownloadUrl;
